<template>
    <div
        v-if="content.hasOwnProperty('stocks') && content.stocks.length>0"
        class="edit_dialog"
    >
        <h5>{{content.company.projectName}}</h5>
        <table v-if="type=='option'">
            <thead>
                <tr>
                    <th>{{'授予时间'|language}}</th>
                    <th>{{'数量'|language}}</th>
                    <th>{{'已行权'|language}}</th>
                    <th>{{'行权价格'|language}}</th>
                    <th>{{'编辑'|language}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="stock in optionStocks">
                    <td>{{stock.date}}</td>
                    <td>{{stock.total}}</td>
                    <td>{{stock.yxq}}</td>
                    <td>{{stock.xqjg}}</td>
                    <td>
                        <a
                            class="waves-effect waves-light"
                            @click="toEdit(stock)"
                        >
                            <img
                                src="http://static.unicornselected.com/b5be67e0-838e-11e9-9b7a-bf944c367467.svg"
                                alt
                            />
                        </a>
                        <a
                            class="waves-effect waves-light"
                            @click="delStock(stock)"
                        >
                            <img
                                src="http://static.unicornselected.com/b5bf0420-838e-11e9-9b7a-bf944c367467.svg"
                                alt
                            />
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
        <table v-else-if="type=='rsu'">
            <thead>
                <tr>
                    <th>{{'授予时间'|language}}</th>
                    <th>{{'数量'|language}}</th>
                    <th>{{'已解禁'|language}}</th>
                    <th>{{'编辑'|language}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="stock in rsvStocks">
                    <td>{{stock.date}}</td>
                    <td>{{stock.total}}</td>
                    <td>{{stock.yjj}}</td>
                    <td>
                        <a
                            class="waves-effect waves-light"
                            @click="toEdit(stock)"
                        >
                            <img
                                src="http://static.unicornselected.com/b5be67e0-838e-11e9-9b7a-bf944c367467.svg"
                                alt
                            />
                        </a>
                        <a
                            class="waves-effect waves-light"
                            @click="delStock(stock)"
                        >
                            <img
                                src="http://static.unicornselected.com/b5bf0420-838e-11e9-9b7a-bf944c367467.svg"
                                alt
                            />
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-show="stock">
            <StockDialog
                @closed="closeStock"
                @submited="submited"
                ref="stockDialog"
            ></StockDialog>
        </div>
        <div v-if="isDelete">
            <simple-dialog
                title=""
                :cancel-text="en?'cancel':'取消'"
                :confirmText="en?'confirm':'确认'"
                :content="en?'Do you want to delete this record?':'是否删除该记录'"
                @confirm="doDelete"
                @cancel="isDelete = false"
            />
        </div>
    </div>
</template>

<script>
import { HttpClient } from '../../util/http';
import StockDialog from '../dialog/StockDialog';
import simpleDialog from './simpleDialog';
export default {
    data() {
        return {
            content: this.item,
            stock: false,
            isDelete: false,
            delId: '',
        };
    },
    components: {
        StockDialog,
        simpleDialog,
    },
    props: {
        item: { type: Object },
        type: {
            type: String,
            default: 'option',
        },
    },
    watch: {
        'optionStocks.length'(val) {
            if (this.type == 'option' && val == 0) {
                this.$emit('changeType', 'rsu');
            }
        },
        'rsvStocks.length'(val) {
            if (this.type == 'rsu' && val == 0) {
                this.$emit('changeType', 'option');
            }
        },
    },
    computed: {
        optionStocks() {
            // console.log(this.content.stocks)
            return this.content
                ? [].concat(
                      this.content.stocks.filter(it => it.type == 'option'),
                  )
                : [];
        },
        rsvStocks() {
            return this.content
                ? [].concat(this.content.stocks.filter(it => it.type == 'rsu'))
                : [];
        },
    },
    methods: {
        // 删除当前公司信息 要传过来当前公司id
        delStock(stock) {
            // await DialogUtil.dialogConfirm(DialogUtil.acitonConfirm);
            this.delId = stock._id;
            // this.fetchData();
            this.isDelete = true;
        },
        async doDelete() {
            await HttpClient.post('/stock/delete', {
                stock: this.delId,
            });
            // this.state = false;
            this.stock = false;
            this.fetchData();
            this.isDelete = false;
            M.toast({ html: this.en ? 'delete successfully!' : '删除成功!' });
        },
        // 弹出一个dialog 用于修改当前公司信息 可以复用添加框
        toEdit(stocks) {
            // console.log(company._id, stocks.type);
            this.stock = true;
            this.$refs.stockDialog.init(stocks);
            // this.state = false;
            // this.$emit('change', this.state);
        },
        closeStock() {
            this.stock = false;
        },
        async fetchData() {
            let content = await HttpClient.get(
                `/stock/company?company=${this.content.company._id}`,
            );
            this.content.stocks = [].concat(content.stocks);
        },
        submited() {
            this.stock = false;
            this.fetchData();
        },
    },
};
</script>

<style lang="less" scoped>
.edit_dialog {
    width: 1000px;
    // height: 100%;
    border-radius: 5px;
    box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    position: fixed;
    top: 300px;
    z-index: 999;
    background-color: #fff;

    h5 {
        padding-left: 100px;
        line-height: 50px;
        text-align: left;
        border-bottom: 1px solid #ccc;
    }
    table {
        height: auto !important;
    }
    table tbody {
        display: block;
        max-height: 300px !important;
        overflow-y: auto;
    }

    table thead,
    tbody tr {
        display: table;

        width: 100%;

        table-layout: fixed;
    }
    th,
    td {
        width: 20%;
        text-align: center;
        img {
            margin-left: 10px;
        }
    }
    table thead {
        width: calc(100% - 1em);
    }
}
</style>
